var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M3.769 6.61c0-.325.263-.589.588-.589h11.285c.324 0 .587.264.587.588v9.773a.59.59 0 0 1-.587.587H4.357a.59.59 0 0 1-.588-.587zm1.175.587v8.597h10.11V7.197z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M15.64 10.332H4.355V9.156H15.64zM13.488 6.608v-2.14h1.175v2.14zM9.409 6.608v-2.14h1.175v2.14zM5.337 6.608v-2.14h1.176v2.14z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;